import * as React from 'react';
import * as api from 'app/shared/api';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Loader } from 'app/shared/ui/Loader';
import { Alert } from 'antd';
import { getSelectedProductType } from "../selectors";
import { Action } from 'app/actions';
import AccommodationGridView from '../components/AccommodationGrid';
import CoursesGridView from '../components/CoursesGrid';
import AddOnsGridView from '../components/AddOnsGrids';
import TransfersGridView from '../components/TransfersGrid';
import FeesGridView from '../components/FeesGrid';
import PackagesGridView from '../components/PackagesGrid';

export interface ProductGridsProps {

}

interface StateProps {
    selectedProductType: string
}

interface DispatchProps {
}

type InternalProps = StateProps & DispatchProps;

const ProductGridsView = (props:InternalProps) => (
    <>{ProductGrids(props)}</>
);

function ProductGrids(props:InternalProps) {

    const renderView = (productType: string) => {
        switch(productType){
            case "Accommodation":
                return <AccommodationGridView />
            case "Courses":
                return <CoursesGridView />
            case "AddOns":
                return <AddOnsGridView />
            case "Transfers":
                return <TransfersGridView />
            case "Fees":
                return <FeesGridView />
            case "Packages":
                return <PackagesGridView />
            default:
                return (
                    <Alert
                        type="info"
                        showIcon
                        title="Select a product type"
                        description="Please select a products type from the above tabs."
                    />
                );
        }
    };

    return(
        renderView(props.selectedProductType)
    );
}

const mapStateToProps = (state: any, ownProps: ProductGridsProps) : StateProps => {
    return {
        selectedProductType: getSelectedProductType(state),
    };
}

const mapDispatchToProps = (dispatch:Dispatch<Action>) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ProductGridsView);
